import { Injectable } from "@angular/core";
import { Subject } from "rxjs/Subject";
import { InputManager } from "./input-manager";
var RenderLoop = (function () {
    function RenderLoop(input_manager) {
        this.input_manager = input_manager;
        this.time_step = 1000 / 60;
        this.dt = 1 / 60;
        this.frames_per_second = 60;
        this.frames_this_second = 0;
        this.render_events = new Subject();
        this.update_events = new Subject();
        this.total_time_updates = new Subject();
        this.rAF_begin = new Subject();
        this.pause_updates_ = false;
    }
    Object.defineProperty(RenderLoop.prototype, "fps", {
        get: function () {
            return this.frames_per_second;
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    RenderLoop.prototype.begin = function () {
        var _this = this;
        this.previous_time = performance.now();
        this.accumulated_time = 0;
        this.total_time = 0;
        this.cancel_token = requestAnimationFrame(function (time) {
            _this.last_fps_update = performance.now();
            _this.update(time);
        });
    };
    ;
    RenderLoop.prototype.update = function (time_now) {
        var _this = this;
        this.cancel_token = requestAnimationFrame(function (time) {
            _this.update(time);
        });
        this.rAF_begin.next(time_now);
        if (time_now > this.last_fps_update + 1000) {
            this.frames_per_second = 0.25 * this.frames_this_second + 0.75 * this.frames_per_second;
            this.last_fps_update = time_now;
            this.frames_this_second = 0;
        }
        this.frames_this_second++;
        if (!this.pause_updates_) {
            var delta_time = time_now - this.previous_time;
            this.accumulated_time += delta_time;
            while (this.accumulated_time > this.time_step) {
                this.update_events.next(this.dt);
                this.accumulated_time -= this.time_step;
            }
            this.previous_time = time_now;
            this.input_manager.update();
            this.total_time += delta_time;
            this.total_time_updates.next(this.total_time);
        }
        var alpha = this.pause_updates_ ? 1 : this.accumulated_time / this.time_step;
        this.render_events.next(alpha);
    };
    ;
    RenderLoop.prototype.pauseUpdates = function () {
        this.pause_updates_ = true;
    };
    ;
    RenderLoop.prototype.stop = function () {
        this.cancel_token && cancelAnimationFrame(this.cancel_token);
        this.pause_updates_ = false;
    };
    ;
    RenderLoop.decorators = [
        { type: Injectable },
    ];
    RenderLoop.ctorParameters = function () { return [
        { type: InputManager, },
    ]; };
    return RenderLoop;
}());
export { RenderLoop };
;
//# sourceMappingURL=render-loop.js.map